import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/settings` redirects to the General section (PLAN-10 §6 step 4). The settings
 * module owns the sub-route tree under here.
 */
export const Route = createFileRoute('/_authed/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/general' })
  },
})
